<template>
    <van-list
        v-model="loadingData"
        :finished="finished"
        finished-text="没有更多了"
        class="article-list"
        :immediate-check="immediate"
        @load="onLoad">
        <article-item
            v-for="(item, index) in list"
            :key="index"
            :item="item"
            @click="handleDetail">
        </article-item>
    </van-list>
</template>

<script>
import ArticleItem from '@/components/articleItem'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    mixins: [tools],
    components: {
        ArticleItem
    },
    props: {
        category: {
            type: Object,
            default: () => ({})
        },
        keyword: {
            type: String,
            default: ''
        },
        immediate: Boolean,
        collected: Boolean
    },
    computed: {
        categoryId() {
            return this.category.id
        },
        categoryName() {
            return this.category.name
        }
    },
    watch: {
        'categoryId': {
            handler(n) {
                if (n) {
                    this.reload()
                }
            },
            immediate: true
        },
        // categoryId(n, o) {
        //     if (n) {
        //         this.reload()
        //     }
        // },
        keyword: {
            handler(val) {
                this.reload()
            }
        }
    },
    data() {
        return {
            loadingData: false,
            finished: false,
            pageNum: 1,
            list: []
        }
    },
    methods: {
        handleDetail(row) {
            this.windowPush(`/article-detail?id=${row.id}&name=${this.categoryName}&src=${this.$route.query.src}`)
        },
        reload() {
            this.pageNum = 1
            this.list = []
            this.finished = false
            this.loadingData = true
            this.onLoad()
        },
        onLoad() {
            const params = {
                category_id: this.categoryId,
                page: this.pageNum,
                page_size: 10,
                collected: this.collected
            }
            if (this.keyword) params.name = this.keyword
            api.getArticleList(params).then((res) => {
                if (res.data.list && res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.list.push({ ...item })
                    })
                    this.pageNum++
                    this.loadingData = false
                    if (res.data.list.length < 10) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
